"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ConnectionObject_3d_1 = __importDefault(require("../utils/ConnectionObject.3d"));
const utils_1 = require("../utils");
const consts_1 = require("../consts");
const FastenerPreviewHelper_3d_1 = __importDefault(require("./FastenerPreviewHelper.3d"));
class FastenerHoverHelper {
    // eslint-disable-next-line consistent-return
    onHover(fastenerIntersection, connectionObject, allConnectionObjects) {
        var _a;
        if (FastenerPreviewHelper_3d_1.default.isEditingActive) {
            return;
        }
        const selectedConnections = allConnectionObjects.filter((connection) => connection.areFastenersSelected());
        this.onMouseEnter(selectedConnections, allConnectionObjects);
        if (!fastenerIntersection) {
            this.onMouseLeave(connectionObject, allConnectionObjects);
            return;
        }
        const selectedFastenerParent = (_a = fastenerIntersection === null || fastenerIntersection === void 0 ? void 0 : fastenerIntersection.object) === null || _a === void 0 ? void 0 : _a.parent;
        if (!selectedFastenerParent) {
            this.onMouseLeave(connectionObject, allConnectionObjects);
            return;
        }
        let selectedConnection = selectedFastenerParent;
        while (selectedConnection && !utils_1.Utils.isConnection(selectedConnection)) {
            selectedConnection = selectedConnection.parent;
        }
        if (selectedConnection && selectedConnection instanceof ConnectionObject_3d_1.default) {
            this.onMouseEnter([selectedConnection], allConnectionObjects);
        }
    }
    onMouseEnter(currentConnections, allConnections) {
        currentConnections.forEach((connection) => connection === null || connection === void 0 ? void 0 : connection.selectFasteners());
        const panelToExtrusionSideConnection = currentConnections === null || currentConnections === void 0 ? void 0 : currentConnections.find((connection) => connection.isPanelToExtrusionSideConnection);
        if (panelToExtrusionSideConnection) {
            this.setActivePanelToExtrusionSideConnections(panelToExtrusionSideConnection, allConnections);
        }
    }
    onMouseLeave(currentConnection, allConnections) {
        const selectedConnections = allConnections.filter((connection) => connection.areFastenersSelected());
        const isPanelToExtrusionSideConnection = selectedConnections.some((c) => c.isPanelToExtrusionSideConnection);
        const [selectedConnection] = selectedConnections;
        currentConnection === null || currentConnection === void 0 ? void 0 : currentConnection.unselectFasteners();
        if (isPanelToExtrusionSideConnection && selectedConnection) {
            this.setActivePanelToExtrusionSideConnections(selectedConnection, allConnections);
        }
    }
    setActivePanelToExtrusionSideConnections(currentConnection, allConnections) {
        if (!currentConnection.isPanelToExtrusionSideConnection) {
            return;
        }
        const { connectedItem: currentExtrusion, mainItem: currentPanel } = currentConnection.getConnectionItems();
        allConnections.forEach((connection) => {
            if (!connection.isPanelToExtrusionSideConnection) {
                return;
            }
            const { connectedItem: extrusion, mainItem: panel } = connection.getConnectionItems();
            if ((extrusion === null || extrusion === void 0 ? void 0 : extrusion.itemNumber) === (currentExtrusion === null || currentExtrusion === void 0 ? void 0 : currentExtrusion.itemNumber) && (currentPanel === null || currentPanel === void 0 ? void 0 : currentPanel.uuid) === (panel === null || panel === void 0 ? void 0 : panel.uuid)) {
                connection.showSelectionBox(consts_1.consts.ACTIVE_SELECTION_BOX_COLOR_VECTOR);
            }
        });
    }
}
exports.default = FastenerHoverHelper;
